import React from 'react';

import { SplitView } from '@/common/components/SplitView/SplitView';
import { SplitViewMap } from '@/common/components/SplitView/Home.SplitViewMap';

import { FeatureSearch } from './components/FeatureSearch/FeatureSearch';
import { GridImageLayer } from './components/GridImageLayer/GridImageLayer';
import { SelectedFeaturePanel } from './components/SelectedFeaturePanel/SelectedFeaturePanel';
import { useSelectedFeature } from './hooks/useSelectedFeature';

export function HomeComponent() {
  const { selectedFeature, unselectFeature } = useSelectedFeature();

  return (
    <SplitView
      textPanel={
        selectedFeature && <SelectedFeaturePanel onClose={unselectFeature} />
      }
      mapPanel={
        <SplitViewMap>
          <FeatureSearch />
          <GridImageLayer />
        </SplitViewMap>
      }
    />
  );
}
